import React from "react"
import {Portal} from "../../types/securityTypes"
import {i18n} from "../../i18n/i18n"

export const getGreetingsModalInfoText = () => ({
    [Portal.Content]: {
        SCHOOL: (
            <>
                <p>{i18n.t`greetings:content.school.p1`}</p>
                <p>{i18n.t`greetings:content.school.p2`}</p>
                <p>{i18n.t`greetings:content.school.p3`}</p>
            </>
        ),
        BUSINESS: (
            <>
                <p>{i18n.t`greetings:content.business.p1`}</p>
                <p>{i18n.t`greetings:content.business.p2`}</p>
                <p>{i18n.t`greetings:content.business.p3`}</p>
            </>
        ),
        HIGHER_ED: (
            <>
                <p>{i18n.t`greetings:content.higher_ed.p1`}</p>
                <p>{i18n.t`greetings:content.higher_ed.p2`}</p>
                <p>{i18n.t`greetings:content.higher_ed.p3`}</p>
            </>
        ),
    },
    [Portal.Creative]: (
        <>
            <p>{i18n.t`greetings:creative.p1`}</p>
            <p>{i18n.t`greetings:creative.p2`}</p>
        </>
    ),
    [Portal.Menu]: {
        SCHOOL: (
            <>
                <p>{i18n.t`greetings:menu.school.p1`}</p>
                <p>{i18n.t`greetings:menu.school.p2`}</p>
                <p>{i18n.t`greetings:menu.school.p3`}</p>
            </>
        ),
        BUSINESS: (
            <>
                <p>{i18n.t`greetings:menu.business.p1`}</p>
                <p>{i18n.t`greetings:menu.business.p2`}</p>
                <p>{i18n.t`greetings:menu.business.p3`}</p>
            </>
        ),
        HIGHER_ED: (
            <>
                <p>{i18n.t`greetings:menu.higher_ed.p1`}</p>
                <p>{i18n.t`greetings:menu.higher_ed.p2`}</p>
                <p>{i18n.t`greetings:menu.higher_ed.p3`}</p>
            </>
        ),
    },
    [Portal.Messages]: {
        SCHOOL: (
            <>
                <p>{i18n.t`greetings:messages.school.p1`}</p>
                <p>{i18n.t`greetings:messages.school.p2`}</p>
                <p>{i18n.t`greetings:messages.school.p3`}</p>
                <p>{i18n.t`greetings:messages.school.p4`}</p>
            </>
        ),
        BUSINESS: (
            <>
                <p>{i18n.t`greetings:messages.business.p1`}</p>
                <p>{i18n.t`greetings:messages.business.p2`}</p>
                <p>{i18n.t`greetings:messages.business.p3`}</p>
                <p>{i18n.t`greetings:messages.business.p4`}</p>
            </>
        ),
        HIGHER_ED: (
            <>
                <p>{i18n.t`greetings:messages.higher_ed.p1`}</p>
                <p>{i18n.t`greetings:messages.higher_ed.p2`}</p>
                <p>{i18n.t`greetings:messages.higher_ed.p3`}</p>
                <p>{i18n.t`greetings:messages.higher_ed.p4`}</p>
            </>
        ),
    },
    [Portal.Reports]: <p>{i18n.t`greetings:reports.p1`}</p>,
    [Portal.Repository]: {
        SCHOOL: (
            <>
                <p>{i18n.t`greetings:library.school.p1`}</p>
                <p>{i18n.t`greetings:library.school.p2`}</p>
                <p>{i18n.t`greetings:library.school.p3`}</p>
                <p>{i18n.t`greetings:library.school.p4`}</p>
            </>
        ),
        BUSINESS: (
            <>
                <p>{i18n.t`greetings:library.business.p1`}</p>
                <p>{i18n.t`greetings:library.business.p2`}</p>
                <p>{i18n.t`greetings:library.business.p3`}</p>
                <p>{i18n.t`greetings:library.business.p4`}</p>
            </>
        ),
        HIGHER_ED: (
            <>
                <p>{i18n.t`greetings:library.higher_ed.p1`}</p>
                <p>{i18n.t`greetings:library.higher_ed.p2`}</p>
                <p>{i18n.t`greetings:library.higher_ed.p3`}</p>
                <p>{i18n.t`greetings:library.higher_ed.p4`}</p>
            </>
        ),
    },
    [Portal.Screens]: (
        <>
            <p>{i18n.t`greetings:screens.p1`}</p>
            <p>{i18n.t`greetings:screens.p2`}</p>
            <p>{i18n.t`greetings:screens.p3`}</p>
        </>
    ),
    [Portal.Student]: (
        <>
            <p>{i18n.t`greetings:student.p1`}</p>
        </>
    ),
    [Portal.Users]: (
        <>
            <p>{i18n.t`greetings:users.p1`}</p>
            <p>{i18n.t`greetings:users.p2`}</p>
            <p>{i18n.t`greetings:users.p3`}</p>
        </>
    ),
    [Portal.Home]: (
        <>
            <p>{i18n.t`greetings:home.p1`}</p>
        </>
    ),
    [Portal.Provider]: (
        <>
            <p>{i18n.t`greetings:provider.p1`}</p>
            <p>{i18n.t`greetings:provider.p2`}</p>
        </>
    ),
    [Portal.Settings]: (
        <>
            <p>{i18n.t`greetings:settings.p1`}</p>
            <p>{i18n.t`greetings:settings.p2`}</p>
        </>
    ),
})
